import { render, staticRenderFns } from "./DialogEditRecebimentoDefinido.vue?vue&type=template&id=607636de&scoped=true"
import script from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"
export * from "./DialogEditRecebimentoDefinido.vue?vue&type=script&lang=js"
import style0 from "./DialogEditRecebimentoDefinido.vue?vue&type=style&index=0&id=607636de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607636de",
  null
  
)

export default component.exports